import { Menu, type MenuMultiSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { AssetTypeStatus, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { AssetTypeStatusIcon } from "../Icons/AssetTypeStatusIcon"
import { MultiSelectItemTemplate, SelectAllItemTemplate } from "../MenuGroups/constants"

export interface AssetTypeStatusMultiSelectGroupProps extends MenuMultiSelectGroupProps<Stored<AssetTypeStatus>> {
	assetTypeStatuses: Stored<AssetTypeStatus>[]
}

export const AssetTypeStatusMultiSelectGroup = memo<AssetTypeStatusMultiSelectGroupProps>((props) => {
	const { ref, assetTypeStatuses, ...rest } = props

	return (
		<Menu.MultiSelectGroup<Stored<AssetTypeStatus>> ref={ref} {...rest}>
			<SelectAllItemTemplate>Select all</SelectAllItemTemplate>
			{assetTypeStatuses.map((assetTypeStatus) => (
				<MultiSelectItemTemplate<Stored<AssetTypeStatus>> key={assetTypeStatus.uuid} value={assetTypeStatus}>
					<AssetTypeStatusIcon assetTypeStatusId={assetTypeStatus.uuid} />
					<Text className="truncate">{assetTypeStatus.name}</Text>
				</MultiSelectItemTemplate>
			))}
		</Menu.MultiSelectGroup>
	)
})
AssetTypeStatusMultiSelectGroup.displayName = "AssetTypeStatusMultiSelectGroup"
